export default "__VITE_ASSET__BdhV97sQ__"